import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'super-';

export default {
    path: '/super',
    name: 'super',
    redirect: {
        name: `${pre}wordspace`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'workspace',
            name: `${pre}workspace`,
            meta: {
                ...meta,
                title: '工作台',
                closable: true
            },
            component: () => import('@/pages/super/workspace')
        },
    ]
};
